<template>
  <ValidationObserver
    ref="profileFormObserver"
    tag="form"
    @submit.prevent="validateProfileBeforeSubmit()"
  >
    <b-loading :is-full-page="true" :active.sync="performingRequest" :can-cancel="true"></b-loading>
    <!-- Informações Básicas -->
    <section>
      <h3 class="title-left-border">Informações Básicas</h3>
      <hr />
      <!-- Foto -->
      <b-field label="Foto" class="flex flex-col">
        <b-progress
          v-if="performingRequest && uploadValue < 100"
          id="progress"
          :value="uploadValue"
          show-value
          format="percent"
        ></b-progress>

        <img class="preview max-w-sm" :src="imagePreview || userProfile.profilePictureUrl || ''" />

        <div class="flex flex-row mt-4">
          <b-upload @input="previewImage" accept="image/*">
            <a class="button">
              <span>{{userProfile.profilePictureUrl ? 'Alterar...' : 'Selecionar arquivo...'}}</span>
            </a>
          </b-upload>

          <span v-if="imageData!=null" class="ml-4">
            <a @click="uploadProfilePicture" class="button is-primary">
              <b-icon icon="upload"></b-icon>
              <span>Enviar</span>
            </a>
          </span>
        </div>
      </b-field>

      <!-- Nome -->
      <span class="columns mt-8 is-multiline">
        <validation-provider
          rules="required|alpha_spaces"
          v-slot="{ errors }"
          name="Nome"
          class="column is-12 is-half-desktop input-name"
        >
          <b-field label="Nome *" :type="{'is-danger': errors[0]}" :message="errors[0]">
            <b-input v-model="userProfile.name" placeholder="NOME" />
          </b-field>
        </validation-provider>

        <validation-provider
          rules="required|alpha_spaces"
          v-slot="{ errors }"
          name="Sobrenome"
          class="column is-12 is-half-desktop input-name"
        >
          <b-field label="Sobrenome *" :type="{'is-danger': errors[0]}" :message="errors[0]">
            <b-input v-model="userProfile.lastName" placeholder="SOBRENOME" />
          </b-field>
        </validation-provider>
      </span>

      <!-- Email -->
      <span class="columns mt-2">
        <validation-provider
          rules="required|email"
          v-slot="{ errors }"
          name="Email"
          class="column is-12 is-half-desktop input-email"
        >
          <b-field label="Email *" :type="{'is-danger': errors[0]}" :message="errors[0]">
            <b-input v-model="userProfile.email" placeholder="EMAIL" />
          </b-field>
        </validation-provider>
      </span>
    </section>
    <!-- Endereço -->
    <section>
      <h3 class="title-left-border">Endereço</h3>
      <hr />
      <span class="columns is-multiline">
        <!-- Logradouro -->
        <validation-provider
          rules="required"
          v-slot="{ errors }"
          name="Logradouro"
          class="column is-12 is-half-desktop input-street"
        >
          <b-field label="Logradouro *" :type="{'is-danger': errors[0]}" :message="errors[0]">
            <b-input
              v-model="professionalProfile.address.street"
              placeholder="Ex.: Avenida Paulista"
            />
          </b-field>
        </validation-provider>

        <!-- Número -->
        <validation-provider
          rules="required"
          v-slot="{ errors }"
          name="Número"
          class="column is-12 is-one-quarter-desktop input-number is-of"
        >
          <b-field label="Número *" :type="{'is-danger': errors[0]}" :message="errors[0]">
            <b-input v-model="professionalProfile.address.number" placeholder="Ex.: 123" />
          </b-field>
        </validation-provider>

        <!-- Complemento -->
        <validation-provider
          rules
          v-slot="{ errors }"
          name="Complemento"
          class="column is-12 is-one-quarter-desktop input-comp is-of"
        >
          <b-field label="Complemento" :type="{'is-danger': errors[0]}" :message="errors[0]">
            <b-input v-model="professionalProfile.address.comp" placeholder="Ex.: Sala 208" />
          </b-field>
        </validation-provider>

        <!-- Bairro -->
        <validation-provider
          rules="required"
          v-slot="{ errors }"
          name="Bairro"
          class="column is-12 is-one-third-desktop input-neighborhood"
        >
          <b-field label="Bairro *" :type="{'is-danger': errors[0]}" :message="errors[0]">
            <b-input
              v-model="professionalProfile.address.neighborhood"
              placeholder="Ex.: Bela Vista"
            />
          </b-field>
        </validation-provider>

        <!-- Cidade -->
        <validation-provider
          rules="required"
          v-slot="{ errors }"
          name="Cidade"
          class="column is-12 is-one-third-desktop input-city"
        >
          <b-field label="Cidade *" :type="{'is-danger': errors[0]}" :message="errors[0]">
            <b-input v-model="professionalProfile.address.city" placeholder="Ex.: São Paulo" />
          </b-field>
        </validation-provider>

        <!-- Estado -->
        <validation-provider
          rules="required|alpha_spaces"
          v-slot="{ errors }"
          name="Estado"
          class="column is-12 is-one-third-desktop input-state"
        >
          <b-field label="Estado *" :type="{'is-danger': errors[0]}" :message="errors[0]">
            <b-input v-model="professionalProfile.address.state" placeholder="Ex.: São Paulo" />
          </b-field>
        </validation-provider>
      </span>
    </section>
    <!-- Informações Profissionais -->
    <section>
      <h3 class="title-left-border">Informações Profissionais</h3>
      <hr />
      <span class="columns is-multiline">
        <!-- Título Profissional -->
        <validation-provider
          rules="required|alpha_spaces"
          v-slot="{ errors }"
          name="Título Profissional"
          class="column is-12 is-half-desktop"
        >
          <b-field
            label="Título Profissional *"
            :type="{'is-danger': errors[0]}"
            :message="errors[0]"
          >
            <b-input v-model="professionalProfile.title" placeholder="Ex.: Psiquiatra" />
          </b-field>
        </validation-provider>

        <!-- Email Profissional -->
        <validation-provider
          rules="required|email"
          v-slot="{ errors }"
          name="Email Profissional"
          class="column is-12 is-half-desktop"
        >
          <b-field label="Email Profissional *" :type="{'is-danger': errors[0]}" :message="errors[0]">
            <b-input
              v-model="professionalProfile.email"
              placeholder="Ex.: contato@psicanálise.com.br"
            />
          </b-field>
        </validation-provider>
      </span>

      <!-- Atendimento -->
      <b-field class="columns flex flex-col my-4 pl-2" label="atendimento">
        <span class="flex flex-row my-4">
          <b-checkbox v-model="professionalProfile.services.online" class="mr-4">Online</b-checkbox>

          <b-checkbox v-model="professionalProfile.services.inPerson">Presencial</b-checkbox>
        </span>
      </b-field>

      <!-- Telefones -->
      <span class="columns mt-4">
        <b-field class="column is-half input-phone" label="Telefone (Whatsapp)">
          <b-input v-model="professionalProfile.phoneNumber1" placeholder="PRINCIPAL" />
        </b-field>
        <b-field class="column is-half input-phone" label="Telefone Secundário">
          <b-input v-model="professionalProfile.phoneNumber2" placeholder="SECUNDÁRIO" />
        </b-field>
      </span>

      <!-- Especialidades -->
      <span class="columns mt-4">
        <validation-provider
          rules="required"
          v-slot="{ errors }"
          name="Especialidades"
          class="column is-12"
        >
          <b-field label="Especialidades *" :type="{'is-danger': errors[0]}" :message="errors[0]">
            <b-taginput
              v-model="professionalProfile.specialties"
              :data="filteredTags"
              autocomplete
              :allow-new="false"
              maxtags="3"
              placeholder="Adicione uma Especialidade"
              @typing="getFilteredTags"
            >
              <template slot-scope="props">{{props.option}}</template>
            </b-taginput>
          </b-field>
        </validation-provider>
      </span>

      <!-- Convênios -->
      <span class="columns mt-4">
        <validation-provider
          rules="alpha_spaces"
          v-slot="{ errors }"
          name="Convênio 1"
          class="column is-one-third"
        >
          <b-field label="Convênio 1" :type="{'is-danger': errors[0]}" :message="errors[0]">
            <b-input
              v-model="professionalProfile.insurances[0]"
              placeholder="Convênio 1"
              maxlength="30"
            />
          </b-field>
        </validation-provider>

        <validation-provider
          rules="alpha_spaces"
          v-slot="{ errors }"
          name="Convênio 2"
          class="column is-one-third"
        >
          <b-field label="Convênio 2" :type="{'is-danger': errors[0]}" :message="errors[0]">
            <b-input
              v-model="professionalProfile.insurances[1]"
              placeholder="Convênio 2"
              maxlength="30"
            />
          </b-field>
        </validation-provider>

        <validation-provider
          rules="alpha_spaces"
          v-slot="{ errors }"
          name="Convênio 3"
          class="column is-one-third"
        >
          <b-field label="Convênio 3" :type="{'is-danger': errors[0]}" :message="errors[0]">
            <b-input
              v-model="professionalProfile.insurances[2]"
              placeholder="Convênio 3"
              maxlength="30"
            />
          </b-field>
        </validation-provider>
      </span>

      <!-- Desconto -->
      <span class="columns mt-4">
        <b-field class="column is-one-third" label="Oferecer desconto para usuários do site ?">
          <b-switch
            v-model="offerDiscount"
            @input="handleSwitchDiscount"
          >{{ offerDiscount ? "Sim": "Não" }}</b-switch>
        </b-field>

        <validation-provider
          rules="integer|max_value:100"
          v-slot="{ errors }"
          name="Desconto"
          class="column is-one-third"
        >
          <b-field
            v-if="professionalProfile.discount > 0"
            label="Porcentagem de Desconto"
            :type="{'is-danger': errors[0]}"
            :message="errors[0]"
          >
            <b-numberinput
              controls-position="compact"
              v-model="professionalProfile.discount"
              min="1"
              max="100"
            ></b-numberinput>
          </b-field>
        </validation-provider>
      </span>

      <!-- Biografia -->
      <b-field label="Biografia">
        <b-input v-model="professionalProfile.biography" type="textarea" />
      </b-field>
    </section>
    <!-- Redes Sociais -->
    <section>
      <h3 class="title-left-border">Redes Sociais</h3>
      <hr />

      <span class="columns is-multiline" v-if="isPremium">
        <!-- Instagram -->
        <validation-provider
          :rules="{ regex: /^https?:\/\/(www\.)?instagram\.com\/([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)\/?$/ }"
          v-slot="{ errors }"
          name="Instagram"
          slim
        >
          <b-field
            class="column is-12 is-half-desktop"
            label="instagram"
            :type="{'is-danger': errors[0]}"
            :message="errors[0]"
          >
            <b-input
              v-model="professionalProfile.socialNetworks.instagram"
              placeholder="https://instagram.com/username"
            />
          </b-field>
        </validation-provider>
        <!-- Facebook -->
        <validation-provider
          :rules="{ regex: /^http(s)?:\/\/(www\.)?(facebook|fb)\.com\/[A-z0-9_\-\.]+\/?$/ }"
          v-slot="{ errors }"
          name="Facebook"
          slim
        >
          <b-field
            class="column is-12 is-half-desktop"
            label="Facebook"
            :type="{'is-danger': errors[0]}"
            :message="errors[0]"
          >
            <b-input
              v-model="professionalProfile.socialNetworks.facebook"
              placeholder="https://facebook.com/username"
            />
          </b-field>
        </validation-provider>
        <!-- Linkedin -->
        <validation-provider
          :rules="{ regex: /^http(s)?:\/\/([\w]+\.)?linkedin\.com\/in\/[A-z0-9_-]+\/?$/ }"
          v-slot="{ errors }"
          name="Linkedin"
          slim
        >
          <b-field
            class="column is-12 is-half-desktop"
            label="Linkedin"
            :type="{'is-danger': errors[0]}"
            :message="errors[0]"
          >
            <b-input
              v-model="professionalProfile.socialNetworks.linkedin"
              placeholder="https://linkedin.com/username"
            />
          </b-field>
        </validation-provider>
        <!-- Twitter -->
        <validation-provider
          :rules="{ regex: /^http(s)?:\/\/(.*\.)?twitter\.com\/[A-z0-9_]+\/?$/ }"
          v-slot="{ errors }"
          name="Twitter"
          slim
        >
          <b-field
            class="column is-12 is-half-desktop"
            label="Twitter"
            :type="{'is-danger': errors[0]}"
            :message="errors[0]"
          >
            <b-input
              v-model="professionalProfile.socialNetworks.twitter"
              placeholder="https://twitter.com/username"
            />
          </b-field>
        </validation-provider>
      </span>
      <span v-else>
        Você ainda não tem acesso a esse recurso.
        <a
          href="javascript:void(0)"
          class="font-bold underline"
          @click="setActiveDashboardSection('subscriptionSection')"
        >Atualize</a> para o plano premium para adicionar redes sociais ao seu perfil
      </span>
    </section>
    <!-- Action Buttons -->
    <div class="p-3 flex justify-center lg:justify-start">
      <b-button class="mr-4" type="is-primary" native-type="submit">Salvar</b-button>
      <router-link :to="`profiles/${currentUser.uid}`" class="button">Visualizar perfil</router-link>
    </div>
  </ValidationObserver>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getCoordinatesFromLocationNameMixin } from '../../mixins/location.methods'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import * as firebase from 'firebase/app'
import {
  professionalsGeoCollection,
  storage,
  usersCollection
} from '../../firebaseConfig'
import specialties from '../../utils/specialties'

const DEBUG = process.env.NODE_ENV === 'development'

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },

  data () {
    return {
      offerDiscount: false,
      imageData: null,
      imagePreview: null,
      uploadValue: 0,
      specialties,
      performingRequest: false,
      filteredTags: [],
      profile: {
        picture: null
      }
    }
  },

  mixins: [getCoordinatesFromLocationNameMixin],

  mounted () {
    this.$store.dispatch('fetchSpecialties')
    if (this.professionalProfile.discount > 0) {
      this.offerDiscount = true
    }

    this.$store.dispatch('fetchPremiumStatus')
  },

  computed: {
    ...mapState([
      'userProfile',
      'currentUser',
      'professionalProfile',
      'isPremium'
    ])
  },

  methods: {
    ...mapActions(['setActiveDashboardSection']),
    previewImage (file) {
      if (!file.name.includes('.') || file.size === 0) {
        this.file = null
        return this.$toasted.error('Por favor, adicione um arquivo válido')
      }

      if (file.size > 1024 * 1024 * 5) {
        this.file = null
        return this.$toasted.error('A imagem deve ser menor que 5MB')
      }

      this.uploadValue = 0
      this.imageData = file
      this.profile.picture = null

      const reader = new FileReader()

      reader.onload = e => {
        this.imagePreview = e.target.result
      }

      reader.readAsDataURL(file)
    },

    async uploadProfilePicture () {
      this.performingRequest = true
      this.profile.picture = null

      const storageRef = storage.ref(
        `${this.currentUser.uid}/avatar/${this.imageData.name}`
      )

      try {
        await storageRef.put(this.imageData).on(
          'state_changed',
          snapshot => {
            this.uploadValue =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          },
          error => {
            this.performingRequest = false

            DEBUG && console.log(error.message)
          },
          async () => {
            await this.updateProfilePictureUrl(storageRef)

            this.$toasted.success('Imagem enviada com sucesso!')
          }
        )
      } catch (error) {
        DEBUG && console.error(error)
        this.$toasted.error(
          'Um erro ocorreu ao enviar a imagem. Tente novamente mais tarde.'
        )
      } finally {
        this.performingRequest = false
      }
    },

    async updateProfilePictureUrl (storageRef) {
      this.performingRequest = true

      try {
        const url = await storageRef.getDownloadURL()

        this.profile.picture = url

        await usersCollection.doc(this.currentUser.uid).update({
          profilePictureUrl: url
        })
      } catch (error) {
        DEBUG && console.error(error)
        throw new Error(error)
      } finally {
        this.performingRequest = false
      }
    },

    handleSwitchDiscount () {
      if (this.offerDiscount === false) {
        this.professionalProfile.discount = 0
      } else {
        this.professionalProfile.discount = 1
      }
    },

    getFilteredTags (text) {
      this.filteredTags = this.specialties.filter(option => {
        return (
          option
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0
        )
      })
    },

    async validateProfileBeforeSubmit () {
      const isValid = await this.$refs.profileFormObserver.validate()

      if (isValid) {
        try {
          this.createGeolocatedProfile()
        } catch (error) {
          DEBUG && console.error(error)
        }

        try {
          this.$store.dispatch('updateProfile', this.userProfile)
        } catch (error) {
          DEBUG && console.error(error)
        }
      } else {
        this.$toasted.error(
          'Não foi possivel atualizar seu perfil. Verifique os dados e tente novamente'
        )
      }
    },

    async createGeolocatedProfile () {
      const {
        address: { street, number, city, state }
      } = this.professionalProfile

      const locationQuery = `${street} ${number} ${city} ${state}`

      try {
        this.performingRequest = true
        const coords = await this.getCoordinatesFromLocationName(locationQuery)
        const { Latitude, Longitude } = coords
        const profileData = {
          ...this.professionalProfile,
          userId: this.currentUser.uid,
          name: this.userProfile.name || '',
          lastName: this.userProfile.lastName || '',
          profilePictureUrl: this.userProfile.profilePictureUrl || '',
          coordinates: new firebase.firestore.GeoPoint(Latitude, Longitude)
        }

        await professionalsGeoCollection
          .doc(this.currentUser.uid)
          .set(profileData)

        this.$toasted.success('Dados salvos com sucesso')
      } catch (error) {
        DEBUG && console.error(error)
        this.$toasted.error(error.message)
      } finally {
        this.performingRequest = false
      }
    }
  }
}
</script>
